import { colors } from "Constants";

/** Evaluation insights tabs of Worksheet */
export const GENERAL_INSIGHTS = "general_insights";
export const QUESTION_WISE_INSIGHTS = "question_wise_insights";

/** Scorebook */
export const WORKSHEET_SCOREBOOK = "worksheet_scorebook";
export const OVERALL_EVALUATION = "overall_evaluation";

// Bar chart colors
export const BAR_CHART_COLORS = [
  colors.yellow700,
  colors.yellow600,
  colors.yellow500,
  colors.yellow400,
  colors.yellow300,
  colors.yellow200,
  colors.yellow100,
];
